import { UserService } from './../../../services/user.service';
import { BillingService } from './../../../services/billing.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first, concatMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import * as jquery from 'jquery';
import { map, tap } from 'rxjs/operators';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';

@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss']
})
export class BillingHistoryComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;

  p: any;
  billings = [];
  error = false;
  modalText = 'Loading...';

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private billingService: BillingService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.loadData();

    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Billing History');
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
        }),

        // Get Billing History
        concatMap(() => this.billingService.getUserBillingHistory()),
        map(billingData => billingData.data),
        tap(billingData => this.billings = billingData.billing)

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
